module.exports = __webpack_public_path__ + "static/media/amc-aptihealth-news.547626c3.jpg";